import React, { useState, useEffect } from 'react';
import AddNewTeamStyles from './AddNewTeam.styles';
import CustomDialog from '../../../../global/components/CustomModal/CustomModal';
import { Box, Grid, Step, StepLabel, Stepper, Typography } from '@mui/material';
import CustomButton from '../../../../global/components/CustomButton/CustomButton';
import { ReactComponent as CloseIcom } from '../../../../assets/icons/close.svg';
import PersonalDetails from '../stepper/Personal Details/PersonalDetails';
import { isTruthy, openErrorNotification } from '../../../../helpers/methods';
const stepData = ['Project Information', 'Project Listing', 'Project Media'];

interface CustomProps {
  isDialogOpen: boolean;
  handleCloseAddTeam: Function;
  userId: string;
  idd: string;
  setIdd: Function;
  fromSettingOrLogout?: string;
  tableDataShowHandler: Function;
  edit:Boolean,
  editRowData:any
}

const AddNewTeam = (props: any) => {
  const classes = AddNewTeamStyles;
  const [activeStep, setActiveStep] = useState<number>(0);
  const [completed, setCompleted] = useState<{
    [k: number]: boolean;
  }>({});

  const totalSteps = () => {
    return stepData.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  // step 1 form validation method
  const handleStepOneValidation = () => {
    return true;
  };

  // go to next page method
  const nextStep = (next = activeStep) => {
    if (handleStepOneValidation()) {
      const newActiveStep = isLastStep() && !allStepsCompleted() ? stepData.findIndex((step, i) => !(i in completed)) : next + 1;
      setActiveStep(newActiveStep);
    } else if (next >= 1) {
      setActiveStep(next + 1);
    }
  };

  const backStep = () => {
    setActiveStep(activeStep - 1);
  };

  const handleNextValidation = (index: number) => {
    try {
      if (!props.userId.length) {
        throw 'Please Register  user';
      }
      setActiveStep(index);
      nextStep(index - 1);
    } catch (error: any) {
      openErrorNotification('  Please Register  user');
    }
  };

  const handleClose = () => {
    props.tableDataShowHandler();
    props.handleCloseAddTeam();
  }

  const stepperMethod = () => {
    return (
      <>
        <Stepper activeStep={activeStep} orientation='vertical' sx={classes.stepperStyle}>
          {stepData.map((label, index) => {
            return (
              <Step
                key={index}
                onClick={() => {
                  handleNextValidation(index);
                }}
                sx={{ cusor: 'pointer !important' }}
              >
                <StepLabel sx={classes.stepLabel}>
                  <Typography sx={classes.label}>{label}</Typography>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </>
    );
  };

  const getAllContent = (activeStep: number) => {
    switch (activeStep) {
      case 0:
    return <PersonalDetails  userId={props.userId} newTeamDialogData = {props.newTeamDialogData} edit={props.edit} editRowData={props.editRowData}  idd={props.idd} setIdd={props.setIdd} fromSettingOrLogout={props.fromSettingOrLogout} handleCloseAddTeam={handleClose} />;
     default:
        break;
    }
  };

  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.profileWrapper}>
          {getAllContent(activeStep)}
        </Box>
      </>
    );
  };

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: 'pointer' }}>
        <CloseIcom onClick={handleClose} />
      </Box>
    );
  };

  return (
    <>
      <CustomDialog
        fullScreen={true}
        isDialogOpen={props.isDialogOpen}
        dialogHeaderContent={dialogHeaderContent()}
        dialogTitleContent={dialogTitleContent()}
        handleDialogClose={props.handleCloseAddTeam}
      />
    </>
  );
};

export default AddNewTeam;
